import React, { useEffect } from "react";
import "./App.css";
import gp from "./assets/json/gp.json";
import dentist from "./assets/json/dentist.json";
import specsavers from "./assets/json/specsavers.json";
import logo from "./assets/img/Genric-landscape.png";
import footer from "./assets/img/footer.png";

export type ProviderType = "GP" | "Dentist" | "SpecSavers";
function App() {
  const [searchTerm, setSearchTerm] = React.useState("");
  const [searchType, setSearchType] = React.useState<ProviderType>("GP");

  const [searchResults, setSearchResults] = React.useState<any[]>([]);

  const searchProvider = (term: string) => {
    let searchResults = [];
    switch (searchType) {
      case "GP":
        searchResults = gp.filter(
          (provider: any) =>
            provider.Practice_Name.toLowerCase().includes(term.toLowerCase()) ||
            provider.Address_Town.toLowerCase().includes(term.toLowerCase()) ||
            provider.Address_Line_1.toLowerCase().includes(
              term.toLowerCase()
            ) ||
            provider.Practice_Number.toString()
              .toLowerCase()
              .includes(term.toLowerCase())
        );
        break;
      case "Dentist":
        searchResults = dentist.filter(
          (provider: any) =>
            provider.Practice_Name.toLowerCase().includes(term.toLowerCase()) ||
            provider.Address_Town.toLowerCase().includes(term.toLowerCase()) ||
            provider.Address_Line_1.toLowerCase().includes(
              term.toLowerCase()
            ) ||
            provider.Practice_Number.toString()
              .toLowerCase()
              .includes(term.toLowerCase())
        );
        break;
      case "SpecSavers":
        searchResults = specsavers.filter(
          (provider: any) =>
            provider.Practice_Name.toLowerCase().includes(term.toLowerCase()) ||
            provider.Address_Town.toLowerCase().includes(term.toLowerCase()) ||
            provider.Address_Line_1.toLowerCase().includes(
              term.toLowerCase()
            ) ||
            provider.Practice_Number.toString()
              .toLowerCase()
              .includes(term.toLowerCase())
        );
        break;
    }
    setSearchResults(searchResults);
  };

  const updateType = async (type: ProviderType) => {
    setSearchType(type);
  };
  useEffect(() => {
    var sp = new URLSearchParams(window.location.search);
    if (sp.get("type") == "SpecSavers") {
      setSearchType("SpecSavers");
    }
  });

  useEffect(() => {
    searchProvider(searchTerm);
  }, [searchType]);

  return (
    <div className="App" style={{ overflow: "hidden", maxHeight: "100vh" }}>
      <header className="App-header">
        <img
          src={footer}
          style={{ width: "15em", marginTop: "1em" }}
          alt="Generic Provider Search"
        />
        <h5
          style={{
            color: "slategray",
            marginTop: "1.5em",
            marginBottom: "0.5em",
          }}
        >
          GENRIC Health Provider Search
        </h5>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            console.log("searchType", searchType);
            searchProvider(searchTerm);
          }}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ marginBottom: "10px" }}>
            <select
              value={searchType}
              onChange={(e) => updateType(e.target.value as ProviderType)}
              style={{
                padding: "5px",
                marginRight: "10px",
                borderRadius: "5px",
                border: "1px solid grey",
              }}
            >
              <option value="GP">GP</option>
              <option value="Dentist">Dentist</option>
              <option value="SpecSavers">SpecSavers</option>
            </select>
            <input
              onChange={(e) => setSearchTerm(e.target.value)}
              type="text"
              placeholder="Search for providers..."
              style={{
                padding: "6px",
                borderRadius: "5px",
                border: "1px solid grey",
              }}
            />
          </div>

          <button
            type="submit"
            style={{
              padding: "5px",
              backgroundColor: "#61A60E",
              border: "none",
              borderRadius: "20px",
              cursor: "pointer",
              color: "white",
              minWidth: "8em",
            }}
          >
            Search
          </button>
          <p style={{ color: "slategray", fontSize: "12px", marginTop: "5px" }}>
            *Search by doctor's name, practice number or area
          </p>
        </form>
        <div
          style={{
            maxHeight: "50vh",
            overflow: "scroll",
            marginTop: "1em",
            marginBottom: "5em",
            border: "1px solid lightgrey",
          }}
        >
          {searchType === "GP" && (
            <div>
              <div>
                {searchResults.length == 0 && (
                  <div>
                    <h6 style={{ color: "slategray" }}>No results found</h6>
                    <ul
                      style={{
                        fontSize: "12px",
                        listStyleType: "none",
                        padding: 0,
                        color: "slategray",
                        margin: "2em",
                      }}
                    >
                      <li>
                        For further assistance, please register for on our
                        mobiapp here:{" "}
                        <a href="https://tinyurl.com/yxmp2ey8">
                          https://tinyurl.com/yxmp2ey8
                        </a>
                      </li>
                      <li>or Whatsapp 'Hi' to 072 815 8226</li>
                      <li>
                        call us on{" "}
                        <a
                          href={`tel:086 000 2402`}
                          style={{
                            color: "slategrey",
                            textDecoration: "none",
                            fontSize: "12px",
                          }}
                        >
                          086 000 2402
                        </a>{" "}
                        or email{" "}
                        <a
                          href={`email:NHGcustomercare@nationalhealthcare.co.za`}
                          style={{
                            color: "slategrey",
                            textDecoration: "none",
                            fontSize: "12px",
                          }}
                        >
                          NHGcustomercare@nationalhealthcare.co.za
                        </a>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
              {searchResults.map((result, index) => (
                <div
                  key={index}
                  style={{
                    border: "1px solid #ccc",
                    boxShadow: "2px 2px 12px rgba(0,0,0,0.1)",
                    padding: "10px",
                    margin: "10px 0",
                    justifyContent: "left",
                    display: "flex",
                    flexDirection: "row",
                    flexGrow: 1,
                    flexShrink: 1,
                    flexBasis: "100%",
                    width: "fit-content",
                  }}
                >
                  <div style={{ width: "10em", textAlign: "left" }}>
                    <div>
                      <h6
                        style={{
                          color: "slategray",
                          margin: "auto",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Practice Name
                      </h6>
                      <p style={{ color: "slategray", fontSize: "12px" }}>
                        {result.Practice_Name}
                      </p>
                    </div>
                    <div>
                      <a
                        href={`tel:${result["Business Phone"]}`}
                        style={{
                          color: "slategrey",
                          textDecoration: "none",
                          fontSize: "12px",
                        }}
                      >
                        Contact: {result["Business Phone"]}
                      </a>
                    </div>
                  </div>
                  <div
                    style={{
                      textAlign: "left",
                      width: "10em",
                    }}
                  >
                    <h6
                      style={{
                        color: "slategray",
                        margin: "auto",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      Address
                    </h6>

                    <ul
                      style={{
                        fontSize: "12px",
                        listStyleType: "none",
                        padding: 0,
                        color: "slategray",
                      }}
                    >
                      <li>{result["Address_Line_1"]}</li>
                      <li>{result["Address Line_2"]}</li>
                      <li>{result["Address Suburb"]}</li>
                      <li>{result["Address_Town"]}</li>
                      <li>{result["Address PostCode"]}</li>
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          )}
          {searchType === "Dentist" && (
            <div>
              <div>
                {searchResults.length == 0 && (
                  <div>
                    <h6 style={{ color: "slategray" }}>No results found</h6>
                    <ul
                      style={{
                        fontSize: "12px",
                        listStyleType: "none",
                        padding: 0,
                        color: "slategray",
                        margin: "2em",
                      }}
                    >
                      <li>
                        For further assistance, please register for on our
                        mobiapp here:{" "}
                        <a href="https://tinyurl.com/yxmp2ey8">
                          https://tinyurl.com/yxmp2ey8
                        </a>
                      </li>
                      <li>or Whatsapp 'Hi' to 072 815 8226</li>
                      <li>
                        call us on{" "}
                        <a
                          href={`tel:086 000 2402`}
                          style={{
                            color: "slategrey",
                            textDecoration: "none",
                            fontSize: "12px",
                          }}
                        >
                          086 000 2402
                        </a>{" "}
                        or email{" "}
                        <a
                          href={`email:NHGcustomercare@nationalhealthcare.co.za`}
                          style={{
                            color: "slategrey",
                            textDecoration: "none",
                            fontSize: "12px",
                          }}
                        >
                          NHGcustomercare@nationalhealthcare.co.za
                        </a>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
              {searchResults.map((result, index) => (
                <div
                  key={index}
                  style={{
                    border: "1px solid #ccc",
                    boxShadow: "2px 2px 12px rgba(0,0,0,0.1)",
                    padding: "10px",
                    margin: "10px 0",
                    justifyContent: "left",
                    display: "flex",
                    flexDirection: "row",
                    flexGrow: 1,
                    flexShrink: 1,
                    flexBasis: "100%",
                    width: "fit-content",
                  }}
                >
                  <div style={{ width: "10em", textAlign: "left" }}>
                    <div>
                      <h6
                        style={{
                          color: "slategray",
                          margin: "auto",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Practice Name
                      </h6>
                      <p style={{ color: "slategray", fontSize: "12px" }}>
                        {result.Practice_Name}
                      </p>
                    </div>
                    <div>
                      <a
                        href={`tel:${result["Business Phone"]}`}
                        style={{
                          color: "slategrey",
                          textDecoration: "none",
                          fontSize: "12px",
                        }}
                      >
                        Contact: {result["Business Phone"]}
                      </a>
                    </div>
                  </div>
                  <div
                    style={{
                      textAlign: "left",
                      width: "10em",
                    }}
                  >
                    <h6
                      style={{
                        color: "slategray",
                        margin: "auto",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      Address
                    </h6>

                    <ul
                      style={{
                        fontSize: "12px",
                        listStyleType: "none",
                        padding: 0,
                        color: "slategray",
                      }}
                    >
                      <li>{result["Address_Line_1"]}</li>
                      <li>{result["Address Line_2"]}</li>
                      <li>{result["Address Suburb"]}</li>
                      <li>{result["Address_Town"]}</li>
                      <li>{result["Address PostCode"]}</li>
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          )}
          {searchType === "SpecSavers" && (
            <div>
              <div>
                {searchResults.length == 0 && (
                  <div>
                    <h6 style={{ color: "slategray" }}>No results found</h6>
                    <ul
                      style={{
                        fontSize: "12px",
                        listStyleType: "none",
                        padding: 0,
                        color: "slategray",
                        margin: "2em",
                      }}
                    >
                      <li>
                        For further assistance, please register for on our
                        mobiapp here:{" "}
                        <a href="https://tinyurl.com/yxmp2ey8">
                          https://tinyurl.com/yxmp2ey8
                        </a>
                      </li>
                      <li>or Whatsapp 'Hi' to 072 815 8226</li>
                      <li>
                        call us on{" "}
                        <a
                          href={`tel:086 000 2402`}
                          style={{
                            color: "slategrey",
                            textDecoration: "none",
                            fontSize: "12px",
                          }}
                        >
                          086 000 2402
                        </a>{" "}
                        or email{" "}
                        <a
                          href={`email:NHGcustomercare@nationalhealthcare.co.za`}
                          style={{
                            color: "slategrey",
                            textDecoration: "none",
                            fontSize: "12px",
                          }}
                        >
                          NHGcustomercare@nationalhealthcare.co.za
                        </a>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
              {searchResults.map((result, index) => (
                <div
                  key={index}
                  style={{
                    border: "1px solid #ccc",
                    boxShadow: "2px 2px 12px rgba(0,0,0,0.1)",
                    padding: "10px",
                    margin: "10px 0",
                    justifyContent: "left",
                    display: "flex",
                    flexDirection: "row",
                    flexGrow: 1,
                    flexShrink: 1,
                    flexBasis: "100%",
                    width: "fit-content",
                  }}
                >
                  <div style={{ width: "10em", textAlign: "left" }}>
                    <div>
                      <h6
                        style={{
                          color: "slategray",
                          margin: "auto",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Practice Name
                      </h6>
                      <p
                        style={{
                          color: "slategray",
                          fontSize: "12px",
                        }}
                      >
                        {result.Name}
                      </p>
                    </div>
                    <div>
                      <a
                        href={`tel:${result["Business Phone"]}`}
                        style={{
                          color: "slategrey",
                          textDecoration: "none",
                          fontSize: "12px",
                        }}
                      >
                        Contact: {result["Business Phone"]}
                      </a>
                    </div>
                  </div>
                  <div
                    style={{
                      textAlign: "left",
                      width: "10em",
                    }}
                  >
                    <h6
                      style={{
                        color: "slategray",
                        margin: "auto",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      Address
                    </h6>

                    <ul
                      style={{
                        fontSize: "12px",
                        listStyleType: "none",
                        padding: 0,
                        color: "slategray",
                      }}
                    >
                      <li>{result["Address_Line_1"]}</li>
                      <li>{result["Address Line_2"]}</li>
                      <li>{result["Address Suburb"]}</li>
                      <li>{result["Address_Town"]}</li>
                      <li>{result["Address PostCode"]}</li>
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </header>
      <footer>
        <div
          style={{
            fontSize: "10px",
            margin: "1em",
            position: "absolute",
            bottom: "0",
          }}
        >
          This product is underwritten by GENRIC Insurance Company Limited (FSP
          43638), an Authorised Financial Services Provider and Licensed
          non-life Insurer. National Health Group (Pty) Ltd (Reg:
          2015/130345/07), provides the managed care services for GENRIC
          Insurance Company Limited, and is a registered Managed Care
          Organisation (MCO110). This is not a medical scheme, and the cover is
          not the same as that of a medical scheme. This policy is not a
          substitute for a medical scheme membership.
        </div>
      </footer>
    </div>
  );
}

export default App;
